'use client'

import { Card, Cell, Spacer, Text } from '@vinted/web-ui'
import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/shared/api-client'
import { useBreakpoint } from '@marketplace-web/shared/breakpoints'
import { ContentLoader, ErrorState } from '@marketplace-web/shared/ui-helpers'
import { getProTermsAndConditionsContent } from 'data/api/get-pro-terms-and-conditions-content'
import { transformBusinessAccountsTermsOfUseResponse } from 'data/api/transformers/response/transform-business-accounts-terms-of-use-response'

const ProTermsAndConditions = () => {
  const {
    fetch: fetchProTermsAndConditions,
    transformedData: termsOfUseContent,
    isLoading,
    error,
  } = useFetch(getProTermsAndConditionsContent, transformBusinessAccountsTermsOfUseResponse)
  const breakpoints = useBreakpoint()

  useEffect(() => {
    fetchProTermsAndConditions()
  }, [fetchProTermsAndConditions])

  const renderBannerContent = termsUpdates => {
    return (
      <div className="u-ui-padding-x2-large@desktops">
        <Text as="h1" type={Text.Type.Heading}>
          {termsUpdates.title}
        </Text>
        <div className="u-desktops-only">
          <Spacer size={Spacer.Size.XLarge} />
        </div>
        <div className="u-mobiles-only">
          <Spacer size={Spacer.Size.Medium} />
        </div>
        <div>
          <Text as="span" html>
            {termsUpdates.body}
          </Text>
        </div>
      </div>
    )
  }

  const renderBannerBasedOnBreakpoint = () => {
    if (!termsOfUseContent?.terms_updates) return null

    const { terms_updates } = termsOfUseContent

    if (breakpoints.phones) {
      return (
        <div>
          <Spacer size={Spacer.Size.XLarge} />
          <Card testId="pro-terms-and-conditions-banner">{renderBannerContent(terms_updates)}</Card>
          <Spacer size={Spacer.Size.X4Large} />
        </div>
      )
    }

    return (
      <div>
        <Spacer size={Spacer.Size.X2Large} />
        <Card styling={Card.Styling.Elevated} testId="pro-terms-and-conditions-banner">
          {renderBannerContent(terms_updates)}
        </Card>
        <Spacer size={Spacer.Size.X4Large} />
      </div>
    )
  }

  if (error) return <ErrorState />
  if (isLoading || !termsOfUseContent)
    return (
      <ContentLoader
        styling={ContentLoader.Styling.Wide}
        testId="pro-terms-and-conditions-loader"
      />
    )

  return (
    <Card>
      <Cell styling={Cell.Styling.Wide}>
        {renderBannerBasedOnBreakpoint()}
        <Text as="h1" type={Text.Type.SectionHeading}>
          {termsOfUseContent.title}
        </Text>
        <Spacer size={Spacer.Size.XLarge} />
        <div className="user-created-content">
          <Text as="span" type={Text.Type.Body} html>
            {termsOfUseContent.body}
          </Text>
        </div>
      </Cell>
    </Card>
  )
}

export default ProTermsAndConditions
